import { BusinessSubscriptionModel } from '@pukka/api';
import { addDays, differenceInDays, isAfter, isSameDay } from 'date-fns';

/*
  M6-M2: popup only show 2 times per one scheme / month
  once in first 2 weeks
  once in the rest of it
  M1: popup show 1 times per week
*/
function shouldShowPopup(discountSettings: BusinessSubscriptionModel.DiscountSettings, today: Date, lastSeen?: string) {
  if (lastSeen) {
    const { discount_schemes: discountSchemes } = discountSettings;

    if (!discountSchemes || discountSchemes.length < 1) {
      return false;
    }

    const selectedIndex = discountSchemes.findIndex((discount) => discount.selected);
    const selected = discountSchemes[selectedIndex];

    if (!selected?.start_date) {
      return false;
    }

    const startDate = new Date(selected.start_date);
    const lastSeenDate = new Date(lastSeen);

    const todayAndStartDiff = differenceInDays(today, startDate);

    let finalStartWeekDay = 0;
    let interval = 0;

    if (selectedIndex < 5) {
      // M6 - M2
      // loop 14, 0 (every 14 days / 2 weeks)
      finalStartWeekDay = 14;
      interval = 14;
    } else {
      // M1
      // loop 28, 21, 14, 7, 0 (every 7 days / 1 week)
      finalStartWeekDay = 28;
      interval = 7;
    }

    for (let day = finalStartWeekDay; day >= 0; day -= interval) {
      if (todayAndStartDiff >= day) {
        const startOfTheWeek = addDays(startDate, day);
        const isLastSeenAfterStartOfTheWeek = isSameDay(lastSeenDate, startOfTheWeek) || isAfter(lastSeenDate, startOfTheWeek);

        if (isLastSeenAfterStartOfTheWeek) {
          return false;
        }

        break;
      }
    }
  }

  return true;
}

function formatCurrency(value: number) {
  const result = new Intl.NumberFormat('in-ID', {
    style: 'decimal',
    maximumFractionDigits: 0,
  }).format(value);

  return result;
}

function generateGroupedSchemes(discountSchemes: BusinessSubscriptionModel.DiscountScheme[]) {
  const result: BusinessSubscriptionModel.DiscountScheme[] = [];

  for (let i = 0; i < discountSchemes.length; i += 1) {
    const currScheme = discountSchemes[i];

    if (i > 0) {
      let lastEl = result.pop();

      if (currScheme.discount === lastEl?.discount) {
        lastEl = {
          ...lastEl,
          end_date: currScheme.end_date,
          selected: lastEl?.selected || currScheme.selected,
        };

        result.push(lastEl);
      } else {
        if (lastEl) {
          result.push(lastEl);
        }

        result.push(currScheme);
      }
    } else {
      result.push(currScheme);
    }
  }

  return result;
}

export { shouldShowPopup, formatCurrency, generateGroupedSchemes };
